import FadeIn from "./FadeIn";
import Magnetic from "./motion/Magnetic";

const TEXTURE = "https://images.pexels.com/photos/30715673/pexels-photo-30715673.jpeg?auto=compress&cs=tinysrgb&w=1920";

export default function FinalCTA({ onLead, show3D }) {
  return (
    <section data-testid="final-cta-section" className="relative py-32 lg:py-48 overflow-hidden">
      {!show3D && (
        <>
          <img
            src={TEXTURE}
            alt=""
            aria-hidden="true"
            loading="lazy"
            className="absolute inset-0 w-full h-full object-cover opacity-40"
          />
          <div className="absolute inset-0 bg-charcoal/70" />
        </>
      )}
      {show3D && (
        <div className="absolute inset-0 bg-gradient-to-b from-charcoal via-charcoal/30 to-charcoal/70 pointer-events-none" />
      )}
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-gold/50 to-transparent" />
      <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-gold/50 to-transparent" />

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <FadeIn>
          <p className="gold-label mb-7">Private Consultation</p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl tracking-tight text-ivory leading-[1.1]">
            YOUR NEXT MOVE <span className="gold-text-gradient italic">STARTS HERE.</span>
          </h2>
          <p className="mt-7 text-base md:text-lg text-ivory/65 font-light">
            Let's build the right mortgage strategy for your next property.
          </p>
          <div className="mt-11 flex flex-wrap items-center justify-center gap-4">
            <Magnetic>
              <button
                data-testid="final-cta-book-btn"
                onClick={() => onLead("consultation")}
                className="px-12 py-4 text-xs tracking-[0.22em] font-semibold text-charcoal bg-gold hover:bg-champagne transition-colors duration-300 rounded-sm"
              >
                BOOK A CONSULTATION
              </button>
            </Magnetic>
            <Magnetic>
              <button
                data-testid="final-cta-preapproved-btn"
                onClick={() => onLead("pre-approval")}
                className="px-12 py-4 text-xs tracking-[0.22em] font-medium text-ivory border border-white/25 hover:border-gold/60 hover:text-gold transition-colors duration-300 rounded-sm bg-white/5 backdrop-blur-sm"
              >
                GET PRE-APPROVED
              </button>
            </Magnetic>
          </div>
          <p className="mt-10 text-sm text-ivory/55 font-light" data-testid="final-cta-contact">
            Akashdeep Ghai ·{" "}
            <a href="tel:+18257362193" data-testid="final-cta-phone-link" className="text-gold hover:text-champagne transition-colors duration-300">
              (825) 736-2193
            </a>{" "}
            ·{" "}
            <a href="mailto:akkasghai@gmail.com" data-testid="final-cta-email-link" className="text-gold hover:text-champagne transition-colors duration-300">
              akkasghai@gmail.com
            </a>
          </p>
          <p className="mt-6 text-sm text-ivory/55 font-light" data-testid="final-cta-apply-line">
            Ready now?{" "}
            <a
              href="https://secure.dominionlending.ca/?app=25574&lang=en"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="final-cta-apply-link"
              className="text-gold hover:text-champagne transition-colors duration-300 underline underline-offset-4 decoration-gold/40 hover:decoration-champagne"
            >
              Start your secure online application
            </a>
          </p>
          <p className="mt-5 text-xs tracking-[0.18em] text-ivory/40 uppercase">
            No obligation. Expert guidance.
          </p>
        </FadeIn>
      </div>
    </section>
  );
}
